import { CSSResultGroup, html, TemplateResult } from 'lit';
import { OutlineImageSlider } from '../../base/outline-image-slider/outline-image-slider';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-image-slider.css.lit';

/**
 * The Image Slider component
 * @element ghs-image-slider
 * @slot image-<number> - slots are generated in code, component accepts stack of desired elements to display
 */
@customElement('ghs-image-slider')
export class GhsImageSlider extends OutlineImageSlider {
  static styles: CSSResultGroup = [componentStyles];

  imageListTemplate = (): TemplateResult[] => {
    const totalImages = this.getValidImageCount() ?? 0;
    // Override to alter the output structure.
    // @todo this could be updated in the superclass to allow the use of a template for the output.
    // i.e. super.imageListTemplate((current: number, total: number) => html`${current} of ${total}`);
    const template = (current: number, total: number) =>
      html`<span class="current">${current}</span> ${this.site === 'BH'
          ? 'of'
          : '/'} <span class="total">${total}</span>`;
    let counter = 0;
    const templateArr: TemplateResult[] = [];
    while (counter < this.childElementCount) {
      const child = this.children[counter];
      if (child.tagName.toLowerCase() === 'ghs-image') {
        templateArr.push(
          html` <div
            class="splide__slide"
            role="group"
            aria-label="slide ${counter + 1} of ${totalImages}"
          >
            <slot name="image-${counter + 1}"></slot>
            <div aria-hidden="true" class="slide-count">
              <span>${template(counter + 1, totalImages)}</span>
            </div>
          </div>`
        );
      }
      counter++;
    }

    return templateArr;
  };

  getValidImageCount() {
    return Array.from(this.children).filter(
      child => child.tagName.toLowerCase() === 'ghs-image'
    ).length;
  }

  addIcons() {
    const iconPrev: HTMLElement = this.generateIcon('chevron-left');
    const iconNext: HTMLElement = this.generateIcon('chevron-right');
    // Screen reader text for accessibility
    const spanPrev: HTMLElement = this.generateSpan('Previous Slide');
    const spanNext: HTMLElement = this.generateSpan('Next Slide');

    this.prevBtn.innerHTML = '';
    this.prevBtn.appendChild(iconPrev);
    this.prevBtn.appendChild(spanPrev);
    this.nextBtn.innerHTML = '';
    this.nextBtn.appendChild(iconNext);
    this.nextBtn.appendChild(spanNext);
  }

  generateIcon(icon: string) {
    const el = document.createElement('ghs-icon');
    el.setAttribute('name', icon);
    el.setAttribute('size', '30px');
    el.setAttribute('mobile-size', '25px');
    el.setAttribute('site', this.site);
    return el;
  }

  generateSpan(text: string) {
    const el = document.createElement('span');
    el.setAttribute('class', 'sr-only');
    el.innerHTML = text;
    return el;
  }

  firstUpdated() {
    super.firstUpdated();
    this.addIcons();
  }
}
